import { render, staticRenderFns } from "./r-select.vue?vue&type=template&id=52c0fe5c&"
import script from "./r-select.vue?vue&type=script&lang=js&"
export * from "./r-select.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./r-select.vue?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports